/**
 * When static image virtual background is composited in matting.js, the user's
 * video is mirrored in the pipeline and CSS scaleX(-1) must be skipped so
 * background text is not flipped. For blur-only or no VB, the full frame is
 * mirrored via CSS as before.
 *
 * @param {boolean} mirrorOwnVideo – settings.mirrorOwnVideo
 * @param {string|undefined|null|false} virtualBgOrImageId – room.virtualBg or preview selected image id/url
 * @param {string|undefined|null|false} virtualBgEffect – room.virtualBgEffect or preview blur field
 * @returns {boolean} whether VideoView / preview should apply CSS horizontal mirror
 */
export function shouldMirrorLocalWebcamCss(mirrorOwnVideo, virtualBgOrImageId, virtualBgEffect)
{
	if (!mirrorOwnVideo)
	{
		return false;
	}
	const hasStaticImageBackground = Boolean(virtualBgOrImageId) &&
		virtualBgEffect !== 'blur' &&
		virtualBgEffect !== 'lightBlur';

	return !hasStaticImageBackground;
}
